import styled from 'styled-components'

// Status Badge Component
export const StatusBadge = styled.div<{
  $status: 'Featured' | 'In Development' | 'Coming Soon'
}>`
  padding: 0.3rem 0.8rem;
  border-radius: 15px;
  font-size: 0.9rem;
  display: inline-block;
  margin-bottom: 1rem;
  background: ${(props) =>
    props.$status === 'Featured'
      ? 'rgba(78, 205, 196, 0.1)'
      : props.$status === 'In Development'
      ? 'rgba(255, 171, 0, 0.1)'
      : 'rgba(255, 107, 107, 0.1)'};
  color: ${(props) =>
    props.$status === 'Featured'
      ? '#4ECDC4'
      : props.$status === 'In Development'
      ? '#FFAB00'
      : '#ff6b6b'};
`

// Tech Tag Component
export const TechTag = styled.span`
  background: rgba(78, 205, 196, 0.1);
  color: #4ecdc4;
  padding: 0.3rem 0.8rem;
  border-radius: 15px;
  font-size: 0.9rem;
  display: inline-block;
  margin: 0 0.5rem 0.5rem 0;

  @media (max-width: 768px) {
    font-size: 0.8rem;
    padding: 0.25rem 0.6rem;
  }
`

// Link Component
export const StyledLink = styled.a`
  color: #4ecdc4;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
  font-size: 1rem;

  &:hover {
    color: #ff6b6b;
  }

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`

// Button Component
export const Button = styled.button<{ $variant?: 'primary' | 'secondary' }>`
  background: ${(props) =>
    props.$variant === 'secondary'
      ? 'transparent'
      : 'linear-gradient(45deg, #4ecdc4, #ff6b6b)'};
  border: ${(props) =>
    props.$variant === 'secondary' ? '2px solid #4ecdc4' : 'none'};
  color: ${(props) => (props.$variant === 'secondary' ? '#4ecdc4' : 'white')};
  padding: 0.8rem 1.5rem;
  border-radius: 25px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  text-align: center;

  &:hover {
    transform: translateY(-2px);
    background: ${(props) =>
      props.$variant === 'secondary'
        ? '#4ecdc4'
        : 'linear-gradient(45deg, #ff6b6b, #4ecdc4)'};
    color: ${(props) => (props.$variant === 'secondary' ? '#0a0a0a' : 'white')};
    box-shadow: 0 5px 15px rgba(78, 205, 196, 0.3);
  }

  @media (max-width: 768px) {
    padding: 0.6rem 1.2rem;
    font-size: 0.9rem;
  }
`

// Card Component
export const Card = styled.div<{ $variant?: 'minimal' | 'detailed' }>`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: ${(props) =>
    props.$variant === 'detailed' ? 'row' : 'column'};
  height: 100%;

  @media (min-width: 1024px) {
    padding: 2rem;
    gap: ${(props) => (props.$variant === 'detailed' ? '2rem' : '0')};
  }

  @media (max-width: 1023px) {
    padding: 2rem;
    flex-direction: column;
  }

  @media (max-width: 768px) {
    padding: 1.5rem;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  }
`

// Grid Component
export const Grid = styled.div<{ $columns?: number }>`
  display: grid;
  grid-template-columns: ${(props) =>
    props.$columns
      ? `repeat(${props.$columns}, 1fr)`
      : 'repeat(auto-fit, minmax(350px, 1fr))'};
  gap: 2rem;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    padding: 0 1rem;
  }
`

// Container Component
export const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;

  @media (max-width: 768px) {
    padding: 0 1rem;
  }
`

// Section Component
export const Section = styled.section`
  padding: 4rem 0;
  width: 100%;

  @media (max-width: 768px) {
    padding: 2rem 0;
  }
`

// Title Component
export const Title = styled.h2`
  font-size: 2.5rem;
  font-weight: bold;
  color: #ffffff;
  margin: 0 0 1rem 0;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`

// Subtitle Component
export const Subtitle = styled.p`
  font-size: 1.2rem;
  color: #a0a0a0;
  margin: 0 auto 2rem;
  max-width: 600px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 1rem;
    margin-bottom: 1.5rem;
  }
`
